import * as React from "react";
import { useSelector } from "react-redux";

function IDCard({ width = 24.211, height = 25.059, ...props }) {
  const { isDarkTheme } = useSelector(({ common }) => common);
  return (
    <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 -960 960 960"
        fill={isDarkTheme ? "#62BAB3" : "#3c4252"}
        {...props}
      >
        <path
          d="M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm160-160q33 0 56.5-23.5T440-560q0-33-23.5-56.5T360-640q-33 0-56.5 23.5T280-560q0 33 23.5 56.5T360-480ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"
        />
      </svg>
    </span>
  );
}

export default IDCard;

